<template>
  <div class="morda-lenta container">
    <div class="morda-lenta-overlay"></div>
    <div v-if="loader" class="morda-lenta-loader">
      {{ $t("loading.loading") }}
    </div>
    <ul
      v-else-if="!mordaLentaIsEmpty('mordaLenta')"
      class="morda-lenta-list"
      :class="[
        { 'morda-lenta-animate': animate },
        'comb-end' + combEnd,
        'comb-length' + combLength,
      ]"
    >
      <li
        v-for="(card, index) in mordaLentaLocal"
        :key="index"
        :class="[
          {
            'morda-lenta-card': card.rank,
            'morda-lenta-comb-wrapper': !card.rank,
            'first-card': card.rank && index == 0,
            'last-card': card.rank && index == mordaLentaLocal.length - 1,
          },
          'index' + (parseInt(index) + 1),
          'throughIndex' + card.throughIndex,
          'length' + card.length,
          'morda-lenta-item',
        ]"
      >
        <MordaLentaCard v-if="card.rank" :card="card"></MordaLentaCard>
        <ul v-else class="morda-lenta-combination">
          <li
            v-for="(cardInner, indexInner) in card"
            class="morda-lenta-card morda-lenta-card-inner"
            :key="indexInner"
            :class="[
              {
                'morda-lenta-card': card.rank,
                'first-card': index == 0 && indexInner == 0,
                'last-card':
                  index == mordaLentaLocal.length - 1 &&
                  indexInner == card.length - 1,
              },
              'throughIndex' + cardInner.throughIndex,
            ]"
          >
            <MordaLentaCard :card="cardInner"></MordaLentaCard>
          </li>
        </ul>
      </li>
    </ul>

    <p v-else>{{ $t("mordaLenta.noPhoto") }}</p>
    <div class="morda-lenta-button">
      <mordaLentaButtonFund></mordaLentaButtonFund>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import CardFace from "@/components/Blocks/CardFace";
import MordaLentaCard from "@/components/Blocks/MordaLentaCard";
import mordaLentaButtonFund from "@/components/Blocks/MordaLentaButtonFund";

export default {
  name: "mordaLenta",
  props: {
    i18n: Object,
  },
  components: {
    redirectButton,
    CardFace,
    MordaLentaCard,
    mordaLentaButtonFund,
  },
  data() {
    return {
      mordaLentaOriginal: [],
      loader: true,
      animate: false,
      isCombination: false,
      combLength: 0,
      combStart: 0,
      combEnd: 0,
      combination: [],
      // lastScrollPos: 0,
      // ticking: false,
      // isScrolled: false
    };
  },
  computed: {
    ...mapGetters({
      mordaLenta: "mordaLenta/getMordaLenta",
      mordaLentaIsEmpty: "mordaLenta/isEmpty",
      // mordaLentaFund: 'mordaLenta/fetchMordaLentaFund'
    }),
    mordaLentaLocal() {
      if (!this.mordaLentaOriginal.length) {
        this.mordaLentaOriginal = this.mordaLenta.slice(0);
      }

      let arr = [];
      let currentCombination, combIndex, throughIndex;
      let orig = this.mordaLentaOriginal;

      for (let i in orig) {
        orig[i].throughIndex = parseInt(i) + 1;
        if (
          orig[i].combination &&
          (orig[i].combination == currentCombination || !currentCombination)
        ) {
          if (!combIndex) {
            arr.push([]);
            currentCombination = orig[i].combination;
            combIndex = i;
          }
          arr[combIndex].push(orig[i]);
        } else {
          arr.push(orig[i]);
        }
      }
      this.combLength = arr[combIndex] ? arr[combIndex].length : "";

      this.combEnd = combIndex
        ? parseInt(combIndex) + parseInt(arr[combIndex].length)
        : "";
      return arr;
    },
  },
  mounted() {
    this.$store
      .dispatch("mordaLenta/get")
      .then(() => {
        this.loader = false;
      })
      .catch(() => {
        this.loader = false;
      });
    // this.$store.dispatch('mordaLenta/getFund');
  },
  created() {
    this.$store.watch(
      (state, getters) => getters["sockets/message"],
      (msg) => {
        if (msg.event) {
          if (msg.event === "new_mordalenta_card") {
            let newCount = 0;
            let newCards = msg.data.cards.reverse();

            this.$store.dispatch("mordaLenta/setFund", msg.data.prize_fund);

            const addCard = () => {
              this.animate = true;
              this.mordaLentaOriginal.unshift(newCards[newCount]);

              setTimeout(() => {
                this.mordaLentaOriginal.pop();
                this.animate = false;

                newCount++;

                setTimeout(() => {
                  if (newCount < newCards.length) {
                    addCard();
                  } else if (this.isCombination) {
                    let card;
                    let combCount = 0;

                    for (let i in this.mordaLentaOriginal) {
                      card = this.mordaLentaOriginal[i].id;
                      if (this.combination.indexOf(card) >= 0) {
                        this.mordaLentaOriginal[i].combination =
                          "newCombination";
                        combCount++;
                      } else {
                        this.mordaLentaOriginal[i].combination = null;
                      }
                    }

                    if (combCount < this.combination.length) {
                      this.$store.dispatch("mordaLenta/get").then(() => {
                        this.mordaLentaOriginal = this.mordaLenta.slice(0);
                      });
                    }

                    this.isCombination = false;
                    this.combination = [];
                  }
                }, 100);
              }, 500);
            };

            addCard();
          } else if (msg.event === "mordalenta_victory") {
            let soundEl = document.getElementById("win-sound");
            if (soundEl) {
              let winPromise = soundEl.play();
              winPromise
                .then(() => {
                  return;
                })
                .catch(() => {
                  return;
                });
            }
            this.$modal.show("morda-lenta-win", {
              prize: msg.data.prize,
              count: msg.data.count,
              combination: msg.data.combination,
            });
          } else if (msg.event === "mordalenta_combination") {
            this.isCombination = true;
            this.combination = msg.data.ids;
            this.$store.dispatch("mordaLenta/setFund", msg.data.prize_fund);
          }
        }
      }
    );
    // window.addEventListener('scroll', this.checkOverlay);
  },
  // beforeDestroy() {
  //     window.removeEventListener('scroll', this.checkOverlay);
  // },
  // methods: {
  //     checkOverlay() {
  //         this.lastScrollPos = window.pageYOffset;
  //         if (!this.ticking) {
  //             window.requestAnimationFrame(() => {
  //                 if (this.lastScrollPos > 40 && !this.isScrolled) {
  //                     this.isScrolled = true;
  //                 } else if (this.lastScrollPos <= 40 && this.isScrolled) {
  //                     this.isScrolled = false;
  //                 }
  //                 this.ticking = false;
  //             });
  //             this.ticking = true;
  //         }
  //     }
  // }
};
</script>
